import React, { useState,useEffect } from "react";
import api from "views/auth/Api";
// import "../challenges/Challanges.css"
import MyChallanges from "./components/MyChallenges"


const Challanges = () => {
  return (
    <div>
      <MyChallanges/>
    </div>
  );
};

export default Challanges;
